const DataProviderType = {
    PathDataTable: "PathDataTable" as const,
    DataSource: "DataSource" as const
};

export default DataProviderType;
